import { useMemo } from 'react'

import {
  AgentsFilterType,
  ResourceFilterType,
  SpecialisationHealth,
} from 'modules/Monitoring/types'

const resourceFilterTypeToMetricFieldMap: Record<AgentsFilterType, string> = {
  [AgentsFilterType.Scheduled]: 'scheduledAgentIds',
  [AgentsFilterType.Online]: 'onlineAgentIds',
  [AgentsFilterType.Offline]: 'offlineAgentIds',
  [AgentsFilterType.OnBreak]: 'onBreakAgentIds',
  [AgentsFilterType.Absent]: 'absentAgentIds',
  [AgentsFilterType.Overtime]: 'overtimeAgentIds',
  [AgentsFilterType.WrapUp]: 'onWrapUpAgentIds',
}

export const useQueueHealthAgentsParamsMap = (
  data?: SpecialisationHealth[],
  filterType?: ResourceFilterType,
): Map<string, string[]> => {
  const metricField = filterType && resourceFilterTypeToMetricFieldMap[filterType]

  return useMemo(() => {
    const agentIdMap = new Map<string, string[]>()

    if (!data || !metricField) {
      return agentIdMap
    }

    data.forEach(specialisationData => {
      const specId = specialisationData.specialisation.id
      const specIds = specialisationData.metrics[metricField] || []

      agentIdMap.set(specId, specIds)

      specialisationData.queues.forEach(queue => {
        const queueId = queue.queue.id
        const queueIds = queue.metrics[metricField] || []
        agentIdMap.set(queueId, queueIds)
      })
    })

    return agentIdMap
  }, [data, metricField])
}
